import axios from 'axios';

export interface ILoggerMessage {
  message: string;
  details: any;
}

export enum ErrorSeverity {
  error = 'error',
  warn = 'warn',
  info = 'info',
  http = 'http',
  debug = 'debug',
  silly = 'silly',
}

export class LoggerSDK {
  // eslint-disable-next-line class-methods-use-this
  public async sendMessage(loggerMessage : ILoggerMessage, severity: ErrorSeverity) {
    // don't send in development
    if (process.env.NODE_ENV === 'development') return {};

    const API_URL = 'https://logger.tranquifinanzas.com';
    const authorization = 'abc123';

    const response = await axios({
      method: 'post',
      url: API_URL,
      responseType: 'json',
      data: {
        message: loggerMessage.message,
        details: loggerMessage.details,
        severity,
        appName: 'tranqui-app',
      },
      headers: { authorization },
    });
    return response;
  }
}
